import { Fragment } from 'react';
import { Divider } from '@/app/components/divider';
import { Container } from '@/app/components/layouts/container';
import { MenuGroup } from '@/app/components/layouts/top-navigation/shared/menu-group';
import type { NavMenuItemType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
interface SubMenuBaseGridProps {
  isModelBuyingTools?: boolean;
  isDesktop?: boolean;
  items?: NavMenuItemType[];
  onClose?: () => void;
}
export const SubMenuBaseGrid = ({
  isModelBuyingTools = false,
  isDesktop = false,
  items = [],
  onClose
}: SubMenuBaseGridProps) => {
  const isBuyingToolsAndDesktop = isModelBuyingTools && isDesktop;
  return items.map((item, index) => {
    const colClassName = cn({
      [cn('xl:col-span-4', {
        'xl:col-start-3': index % 2 === 0,
        'xl:col-start-7': index % 2 === 1
      })]: !isBuyingToolsAndDesktop,
      'xl:space-y-1 xl:pl-10': isBuyingToolsAndDesktop
    });

    // Empty placeholder: keeps the grid cell blank on desktop, skipped on mobile
    if (!item.title && !item.children) {
      if (!isDesktop) return null;
      return <div key={`menu_base${index}`} className={colClassName} aria-hidden="true" />;
    }
    return <Fragment key={`menu_base${index}`}>
        <MenuGroup item={item} isDesktop={isDesktop} isModelBuyingTools={isModelBuyingTools} className={colClassName} onClose={onClose} />
        {items.length - 1 > index && !isDesktop && <Container size="mobile-only" maxWidth="none">
            <Divider size="xl" />
          </Container>}
      </Fragment>;
  });
};